import EventMonthList from './EventMonthList';
import RangeFormatter from '../../date/EventListingRangeFormatter';

class EventWeekList extends EventMonthList {

  constructor() {
    super();
    this.resultsFormatter = RangeFormatter.weekRange;
  }

  filterResults(perfMap, date) {
    // On week view we *do* want to show the prev/next
    // month's spillover. No additional filtering needed
    return perfMap;
  }

}

export default EventWeekList;
